import { CustomUserProfileFieldDefinition } from 'models/user/userProfileField/definition/CustomUserProfileFieldDefinition';

export class CustomUserProfileFieldDefinitionService {
	toModel(definition) {
		return new CustomUserProfileFieldDefinition(definition);
	}
}
